// DS: DEV1
import { URLS } from '@wix/da-url';
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Points from '@wix/da-ds/pkg/Icons/Points';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { getPointsPriceValidationError, POINTS_MIN_VALUE } from '../utils/profits';
import s from './PointsInput.scss';
export const PointsInput = ({ className, inputClassName, value, maxValue, label, errorMessage, showWhatArePointsLink, onChange, refInput })=>{
    const { t } = useTranslation();
    const handleChange = (ev)=>{
        const stringValue = ev.target.value;
        const limitedValue = Math.abs(+Number(stringValue.slice(0, 6)).toFixed(0));
        onChange(limitedValue, getPointsPriceValidationError(limitedValue, maxValue, t));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['points-input-line']
    }, /*#__PURE__*/ React.createElement(TextInput, {
        id: "points-input",
        className: classnames(s['points-cost-input'], inputClassName),
        value: value ? value.toString() : '',
        validationResult: errorMessage ? 'error' : undefined,
        details: errorMessage,
        onChange: handleChange,
        name: "pointsInput",
        type: "number",
        label: label || t('common.pointsInput.choosePrice'),
        min: POINTS_MIN_VALUE,
        max: maxValue,
        autoComplete: "off",
        ref: refInput
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['input-label']
    }, /*#__PURE__*/ React.createElement(Points, {
        className: s['coins-icon']
    }))), showWhatArePointsLink && /*#__PURE__*/ React.createElement("div", {
        className: s['what-are-points-line']
    }, !!value && /*#__PURE__*/ React.createElement("a", {
        target: "_blank",
        rel: "noreferrer",
        href: URLS.ABOUT_POINTS,
        className: s['what-are-points']
    }, t('common.faq.whatArePoints'))));
};
PointsInput.displayName = 'PointsInput';
export default PointsInput;

//# sourceMappingURL=PointsInput.js.map